module.exports = __webpack_public_path__ + "img/success.bdda762c.png";